import React, { FC } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SCUIGeneralDrawerHeader } from "../../../../atomic/molecules";
import TimeHelper from "../../../../utils/time";
import { OODDC } from "./SCUIOrderDetailDrawerContent.classes";

interface IProps {
  detail?: any;
  onClose?: any;
}

export const SCUIOrderDetailDrawerContent: FC<IProps> = ({
  detail,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <div className={`commentFilterContainer ${OODDC.root}`}>
      <Grid container spacing={2}>
        <SCUIGeneralDrawerHeader
          header={t("order.orderInformation")}
          onClose={onClose}
          rootClassName={OODDC.headerRoot}
          titleClassName={OODDC.headerTitle}
          closeIconClassName={OODDC.headerCloseIcon}
        />
        <p className={`subheadtxt ${OODDC.orderInformationTitle}`}>{t("order.orderInformation")}</p>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowOrderNumber}`}>
            <p className="txtDetailForDrawerTitle">{t("general.orderNo")}</p>
            <p className="txtDetailForDrawerContent">{detail?.orderNumber}</p>
          </div>
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowOrderDate}`}>
            <p className="txtDetailForDrawerTitle">{t("general.orderDate")}</p>
            <p className="txtDetailForDrawerContent">
              {TimeHelper.formatDateHour(detail?.orderDate)}
            </p>
          </div>
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowCost}`}>
            <p className="txtDetailForDrawerTitle">{t("general.cost")}</p>
            <p className="txtDetailForDrawerContent">{detail?.grandTotal}</p>
          </div>
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowStoreCode}`}>
            <p className="txtDetailForDrawerTitle">{t("general.storeCode")}</p>
            <p className="txtDetailForDrawerContent">{detail?.storeCode}</p>
          </div>
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowSellerName}`}>
            <p className="txtDetailForDrawerTitle">{t("general.sellerName")}</p>
            <p className="txtDetailForDrawerContent">{detail?.sellerName}</p>
          </div>
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowPlatform}`}>
            <p className="txtDetailForDrawerTitle">Platform</p>
            <p className="txtDetailForDrawerContent">{detail?.platformName}</p>
          </div>
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowOrderStatus}`}>
            <p className="txtDetailForDrawerTitle">
              {t("general.orderSiparis")} {t("general.status")}
            </p>
            <p className="txtDetailForDrawerContent">
              {detail?.orderStatusName}
            </p>
          </div>
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowLastStatusUpdateDate}`}>
            <p className="txtDetailForDrawerTitle">
              {t("mobileApp.updateDate")}
            </p>
            <p className="txtDetailForDrawerContent">
              {" "}
              {TimeHelper.formatDateHour(detail?.lastStatusUpdateDate)}
            </p>
          </div>
        </Grid>
        <p className={`subheadtxt ${OODDC.shippingInformationTitle}`}>{t("order.shippingInformation")}</p>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowShippingNo}`}>
            <p className="txtDetailForDrawerTitle">{t("general.shippingNo")}</p>
            <p className="txtDetailForDrawerContent">
              {detail?.shippingListNo}
            </p>
          </div>
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowShippingStatus}`}>
            <p className="txtDetailForDrawerTitle">
              {t("general.shipping")} {t("general.status")}
            </p>
            <p className="txtDetailForDrawerContent">
              {detail?.shippingStatusName}
            </p>
          </div>
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <div className={`sideBySideDiv ${OODDC.rowCargoCompany}`}>
            <p className="txtDetailForDrawerTitle">
              {t("general.cargoCompany")}
            </p>
            <p className="txtDetailForDrawerContent">
              {detail?.shippingCompanyName}
            </p>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
